export default "__VITE_ASSET__ByaqQNR9__"